import { render, staticRenderFns } from "./List.vue?vue&type=template&id=f8c5f100&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=f8c5f100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c5f100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8c5f100')) {
      api.createRecord('f8c5f100', component.options)
    } else {
      api.reload('f8c5f100', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=f8c5f100&scoped=true&", function () {
      api.rerender('f8c5f100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/transaction-log/List.vue"
export default component.exports